export const texts = {
  hello: 'salam',
  catalog_sub_title: `Select your personal Grail watch from our giant portfolio of
  pre-owned luxury Swiss watches. Our client advisors are happy to
  provide you with any additional information and will be glad to find
  any non-listed timepiece for you.`,
  heromock_new_arrivals_title: 'New arrivals',
  heromock_all_watches_title: 'Luxury watches',
  heromock_new_arrivals_sub_title: 'Stay up to date with our new products and don’t miss out on our unique offers',
  heromock_all_watches_sub_title: `Explore the wide selection of high end pre-owned Swiss watches and choose your dream timepiece`,
  heromock_brands_title: 'Brands',
  heromock_brands_sub_title:
    'Select from a wide range of luxury Swiss watch brands and start your way to your dream watch',
  brands_feature_brands_title: 'Featured brands',
  brands_our_brands_title: 'All brands',
  brands_our_brands_loading: 'Brands are loading ...',
  heromock_about_us_title: 'About us',
  heromock_about_us_sub_title:
    'We are the market leaders in the sale of watches, as well as we have a very high-quality repair service for watches',
  about_us_about_us_title: 'About us',
  about_us_about_us_sub_title:
    'Chrono 10:10 is a story of emotions and commitment, and every success story has a beginning. The company was founded in 2018 in Prague, the Czech Republic when the concept of a multi-brand store was created as a result of one dream of two enthusiasts, who had been collecting high-end timepieces and admiring horological art for many years.',
  about_us_slider_title_0: 'Supply chain',
  about_us_slider_description_0: 'Wide range of partners and suppliers all over the world',
  about_us_slider_title_1: 'Authenticity guarantee',
  about_us_slider_description_1: 'All our watches are checked for authenticity, condition and clear history',
  about_us_slider_title_2: 'Variety of products',
  about_us_slider_description_2: 'Giant portfolio of products and option to pre-order almost any non-listed models',
  about_us_slider_title_3: 'Years of experience',
  about_us_slider_description_3: 'Years of successful experience with pre-owned Swiss watches',
  about_us_slider_title_4: 'Service center',
  about_us_slider_description_4: 'Having our own professional service center – qualified watchmakers',
  about_us_slider_title_5: 'Satisfied customers',
  about_us_slider_description_5: 'Giant portfolio of products and option to pre-order almost any non-listed models.',
  about_us_company_title: 'Our company',
  about_us_company_description_0: `A sincere handshake, your smile, and a reunion give us the energy to continue on this path and to be even better. Listening to the elusive time and your wishes, founders strive to continuously ensure the quality of our services is unsurpassed.`,
  about_us_company_description_1: `<b>Chrono 10:10 is proud of our many years of successful cooperation with the world's leading watch-selling website Chrono24</b> and the offer we passionately and dedicatedly choose among the best international brands, always taking care to satisfy all tastes and types of customers, events, and occasions. At the same time, being an <b>honored member of Chrono24 Trusted Sellers group</b>, our company has a clear reputation and 100% positive feedback from satisfied clients <b>all over the world.</b>`,
  about_us_company_subtitle: 'Watches for the price of\nyour time',
  about_us_company_text_0_0:
    '\n\nIn 2020 Intercontinental hotel was closed for renovation and our team moved to a beautiful spacy office in the heart of Prague, 1-2 minutes walking from Wenceslas square, in Gallery Myšak, Vodičkova 31.',
  about_us_company_text_0_1:
    'The company is growing and our team now includes professional watch traders and buyers, analysts and watch experts, sales managers, watchmakers, polishers, and back-office support managers. <b>Chrono 10:10</b> has partners and suppliers all over the globe, as well as hundreds of regular clients and consignment agents.',
  about_us_company_text_0_2:
    "Chrono 10:10 believes that the watch is much more than a full-time indicator. More precisely, more than any object or detail, a watch is a reflection of an individual's personal attitude. In just one place, you can not only buy a luxury watch online for yourself or your loved one but also experience all the aesthetic features of enjoying a work of art.",
  about_us_why_chrono: 'Why Chrono 10:10',
  about_us_company_text_1_0:
    'That fine emotion is reflected, both in the eyes of the recipient and in the eyes of the donor. That is the reason why our team loves our business and the basic driver of our business ideas. <br/> <br/> Our team hopes that we have managed to intrigue you and bring you closer to our world. You are always welcome to take your first step or one of many and embark with us on a journey through the magical world of watches.<br/> Why is the secondary market for the luxury Swiss the best option? Here is just so: ',
  about_us_reasons_title_0: 'Variety of target audiences',
  about_us_reasons_description_0:
    'From watch fans dreaming of their Grail watches for years to professional investors and collectors',
  about_us_reasons_title_1: 'Variety of models',
  about_us_reasons_description_1: 'From discontinued or vintage rare watches to the incredibly demanded new models',
  about_us_reasons_title_2: 'Flexible prices',
  about_us_reasons_description_2:
    'Our team follows the market trends daily to provide our clients with the best price options',
  about_us_reasons_title_3: 'Professional service repair',
  about_us_reasons_description_3: 'Our watchmakers have no limits of complications they can work with',
  about_us_reasons_title_4: 'Sustainable fashion',
  about_us_reasons_description_4: 'In this way, you promote and support sustainable fashion',
  about_us_reasons_title_5: 'Sustainable fashion',
  about_us_reasons_description_5: 'In this way, you promote and support sustainable fashion',
  about_us_banner_title: 'Get your quote to sell',
  about_us_banner_sub_title: 'Complete 2 easy steps to receive a quote for your watch',
  about_us_banner_button_text: 'Start',
  heromock_service_page_title: 'High quality service for your watch',
  heromock_service_page_sub_title: `We provide quality service in our in-house service center for watches of any complexity beside selling high class Swiss watches`,
  contact_us: 'Contact us',
  contact_us_subtitle:
    'If you have any questions, we are happy to contact and discuss all details. We will be in touch shortly',
  prices: 'Prices',
  service_center_benefits_title: 'Service center benefits',
  service_center_brands_description:
    'Please note that we do not work with the following brands: Longines, Tissot, Seiko, Oris and fashion brands. ',
  benefitsTitle: 'Service center benefits',
  service_benefits_title_0: 'Professional service',
  service_benefits_title_1: 'Availability of original parts',
  service_benefits_title_2: 'Quality polishing',
  service_benefits_title_3: '1 year warranty',
  service_benefits_title_4: 'Terms and сonditions',
  service_benefits_title_5: `Special service packages `,
  service_benefits_description_0: 'A complete and precise diagnostic of Swiss watches ',
  service_benefits_description_1: 'Replacement of any parts with original spare parts',
  service_benefits_description_2: 'Ultrasound cleaning with modern European equipment',
  service_benefits_description_3: 'All watches servicedare covered by our 1 year warranty',
  service_benefits_description_4: 'High quality service in short terms for reasonable prices.',
  service_benefits_description_5: 'Check our special service packages and choose the right one for you',
  service_center_brands_title: 'Brands we work with',
  service_center_about_banner_title: 'About service',
  service_center_about_banner_subtitle:
    'The service of such an expensive accessory should be carried out by competent specialists.',
  service_center_about_banner_text: `Our professional specialists are certified craftsmen who have been working for more than a ten-years and have successfully solved many problems related to watches. Servicers employed in our service center are trained in top European professional watchmaking education facilities and have a wealth of knowledge, along with huge experience with any kind of complications.`,
  service_center_about_banner_title_1: 'Service',
  service_center_about_banner_subtitle_1: 'We work and can repair uniquely complex mechanisms such as:',
  service_center_about_banner_text_1_0: `Jumping seconds(retrograde seconds)`,
  service_center_about_banner_text_1_1: `Annual calendar`,
  service_center_about_banner_text_1_2: `Perpetual calendar`,
  service_center_about_banner_text_1_3: `Moon phase`,
  service_center_about_banner_text_1_4: `Repeater`,
  service_center_about_banner_text_1_5: `Chronograph`,
  service_center_about_banner_text_1_6: `Time zones`,
  service_center_about_banner_text_1_7: `Equation of time`,
  service_center_about_banner_text_1_8: `Tourbillon`,
  service_center_how_it_works_title: 'How it works',
  brands_work_title: 'Brands that we work with',
  brands_title: 'Shop by brand',
  brands_button: 'View all',
  brands_work_footer:
    'Please note that we do not work with the following brands: Longines, Tissot, Seiko, Oris and fashion brands',
  service_info_block_title: 'Why Chrono 10:10 service center',
  service_info_block_1_description_1:
    'Swiss-made watches are expensive accessories that require a great deal of attention. The timely repair will help to maintain further performance. ',
  service_info_block_1_description_1_1:
    'The reasons for repair can be varied. But the most obvious and common are as follows:',
  service_info_block_description_2:
    'If your Swiss watch is malfunctioning, you should have it checked immediately. In this case, the service of such an expensive accessory should be carried out by a competent specialist, which excludes the possibility of deterioration of performance after repair.',
  service_info_block_2_sub_title_1:
    'The service of such an expensive accessory should be carried out by competent specialists.',
  service_info_block_2_description_1:
    'Our professional specialists are certified craftsmen who have been working for more than a ten-years and have successfully solved many problems related to watches. Servicers employed in our service center are trained in top European professional watchmaking education facilities and have a wealth of knowledge, along with huge experience with any kind of complications.',
  service_info_block_2_sub_title_2: 'We guarantee high service quality and reliable results.',
  service_info_block_2_description_2:
    'The employees of Chrono 10:10 use only European equipment. We service and procure only original spare parts for all brands we represent (such as Rolex, Patek Philippe, Audemars Piguet, F.P. Journe, A. Lange & Söhne, Vacheron Constantin, IWC, Jaeger-LeCoultre, Franck Muller, etc…), and others that many other watchmakers do not even service.',
  service_info_block_2_sub_title_3: 'What services can we offer?',
  service_info_block_2_description_3:
    "Our service team is very well-coordinated and efficient. That's why we are ready to offer the best services, such as:",
  service_info_block_2_sub_title_4:
    'We take great care when it comes to our watches in all price segments and a time of service.',
  service_info_block_2_description_4:
    'Replacement of complex watch parts and glass, cleaning with ultrasonic, cosmetic repairs of the case and bracelet, polishing, and battery replacement are just a part of the services our company provides, but the most important - the quality of repair and the highest level of service you will receive only from us.',
  service_info_block_2_sub_title_5: 'We work and can repair uniquely complex mechanisms such as:',
  service_info_block_2_description_5:
    'Breakage of an expensive accessory almost always costs a pretty penny. We are able to offer all of the above services at a reasonable price and within a short time. We also provide a warranty period after the repair.',
  service_info_block_1_list_items_0: 'Ingress of moisture or dust into the mechanisms',
  service_info_block_1_list_items_1: 'Temperature fluctuations',
  service_info_block_1_list_items_2: 'Damage from dropping or bumping',
  service_info_block_1_list_items_3: 'Wear and tear of the movements over time',
  service_info_block_1_list_items_4: 'Scheduled repairs and diagnostics',
  service_info_block_2_list_items_0: 'A complete diagnosis of Swiss watches by highly skilled craftsmen;',
  service_info_block_2_list_items_1: 'Replacement of any parts with original spare parts that fit your model;',
  service_info_block_2_list_items_2: 'Professional polishing of the accessory, which will give it a new-like look;',
  service_info_block_2_list_items_3: 'Ultrasonic cleaning on modern European equipment;',
  service_info_block_2_list_items_4: 'We are engaged in replacing the batteries of different models of watches;',
  service_info_block_2_list_items_2_0: 'jumping seconds(retrograde seconds)',
  service_info_block_2_list_items_2_1: 'annual calendar',
  service_info_block_2_list_items_2_2: 'perpetual calendar',
  service_info_block_2_list_items_2_3: 'moon phase',
  service_info_block_2_list_items_2_4: 'repeater',
  service_info_block_2_list_items_2_5: 'chronograph',
  service_info_block_2_list_items_2_6: 'time zones',
  service_info_block_2_list_items_2_7: 'equation of time',
  service_info_block_2_list_items_2_8: 'tourbillon',
  service_competent_banner_title: 'Competent specialists',
  service_competent_banner_subtitle:
    'Please note that we do not work with the following brands: Longines, Tissot, Seiko, Oris and fashion brands.',
  service_competent_banner_text:
    'Our professional specialists are certified craftsmen who have been working for more than a ten-years and have successfully solved many problems related to watches. Servicers employed in our service center are trained in top European professional watchmaking education facilities and have a wealth of knowledge, along with huge experience with any kind of complications.',
  service_competent_banner_text_ending: 'We guarantee high service quality and reliable results.',
  service_insta_banner_title: 'What we offer',
  service_insta_banner_subtitle: `Our service team is very well-coordinated and efficient. That's why we are ready to offer the best services, such as:`,
  service_insta_banner_list_item_0: 'A complete diagnosis of Swiss watches',
  service_insta_banner_list_item_1: 'Replacement of any parts with original spare parts that fit your model',
  service_insta_banner_list_item_2: 'Professional polishing of the accessory',
  service_insta_banner_list_item_3: 'Ultrasonic cleaning on modern European equipment',
  service_insta_banner_list_item_4: 'We are engaged in replacing the batteries of different models of watches',
  how_it_works_title_0: '1. Send a picture of the watch',
  how_it_works_description_0:
    'Send us a request and attach pictures of your watch with a short description of preferred services',
  how_it_works_title_1: '2. Get an evaluation',
  how_it_works_description_1: 'Get an evaluation of the required service works with the price and terms estimations',
  how_it_works_title_2: '3. Send us your watch',
  how_it_works_description_2: 'Send or bring us your watch',
  how_it_works_title_3: '4. FREE diagnostics',
  how_it_works_description_3: 'Receive FREE diagnostics report and calculation',
  how_it_works_title_4: '5. Make a payment',
  how_it_works_description_4: 'Make a payment',
  how_it_works_title_5: '6. One year warranty',
  how_it_works_description_5:
    'Get your professional watch repaired with a 1-year warranty for all mechanical parts of the watch',
  how_it_works_title_6: '7. Pick up your watch',
  how_it_works_description_6: 'Pick up your watch',
  how_it_works_title_7: '8. Enjoy your watch',
  how_it_works_description_7: 'Refer us to your friends',
  maintenance_block_title: 'Preventive maintenance of mechanical watches',
  maintenance_block_sub_title: 'Choose the suitable service package from the offered tailor made options',
  maintenance_block_blocks_title_0: 'Business package',
  maintenance_block_blocks_description_0: 'This package is suitable for most brands daily wear watches.',
  maintenance_block_blocks_description2_0:
    '<span>Brands</span>: Omega, Breitling, Rolex, Cartier, Ulysse Nardin, Chopard, Piaget, Glashütte Original, Zenith, Hublot, IWC, Jaquet Droz, Panerai, Jaeger LeCoultre, Daniel Roth',
  maintenance_block_blocks_0_list_items_0: 'Complete overhaul',
  maintenance_block_blocks_0_list_items_1: 'Water resistance test',
  maintenance_block_blocks_0_list_items_2: 'Ultrasonic cleaning of the case/bracelet',
  maintenance_block_blocks_0_list_items_3: '1-year warranty',
  maintenance_block_blocks_title_1: 'Premium package',
  maintenance_block_blocks_description_1: 'Option for more complicated and exceptional watches of Swiss brands.',
  maintenance_block_blocks_description2_1:
    '<span>Brands</span>: A. Lange & Söhne, Audemars Piguet, Breguet, Blancpain, Patek Philippe, Vacheron Constantin, F.P.Journe, Richard Mille, Urwerk, Parmigiani Fleurier',
  maintenance_block_blocks_1_list_items_0: 'Complete overhaul',
  maintenance_block_blocks_1_list_items_1: 'Water resistance test',
  maintenance_block_blocks_1_list_items_2: 'Ultrasonic cleaning of the case/bracelet',
  maintenance_block_blocks_1_list_items_3: '1-year warranty',
  maintenance_block_blocks_title_2: 'Exclusive package',
  maintenance_block_blocks_description_2:
    'You could rely on us in taking care of the most complicated and unique timepieces.',
  maintenance_block_blocks_description2_2: 'Complicated high-end watches of top Swiss brands',
  maintenance_block_blocks_2_list_items_0: 'Complete overhaul',
  maintenance_block_blocks_2_list_items_1: 'Water resistance test',
  maintenance_block_blocks_2_list_items_2: 'Ultrasonic cleaning of the case/bracelet',
  maintenance_block_blocks_2_list_items_3: '1-year warranty',
  maintenance_block_footer:
    '*Indicated prices exclude mechanism parts, glass or strap replacement costs, as well as polishing works if needed',

  maintenance_block_from: 'From',
  services_block_title: 'Price list',
  services_block_sub_title: 'Order one or more services that your watch requires',
  services_block_items_title_0: 'Watch diagnostics',
  services_block_items_title_1: 'Steel polishing',
  services_block_items_1_description_0: 'Steel case polishing',
  services_block_items_1_description_1: 'Steel bracelet polishing',
  services_block_items_1_description_2: 'Full Steel  (case + bracelet) polishing',
  services_block_items_title_2: 'Gold / titanium polishing',
  services_block_items_2_description_0: 'Gold / titanium case polishing',
  services_block_items_2_description_1: 'Gold / titanium bracelet polishing',
  services_block_items_2_description_2: 'Full Gold / titanium (case + bracelet) polishing',
  services_block_items_title_3: 'Platinum polishing',
  services_block_items_3_description_0: 'Platinum case polishing',
  services_block_items_3_description_1: 'Platinum bracelet polishing',
  services_block_items_3_description_2: 'Full (case + bracelet) polishing',
  services_block_items_title_4: 'Ultrasonic cleaning of case and bracelet',
  services_block_items_title_5: 'Strap replacement (excluding the strap cost)',
  services_block_items_title_6: 'Strap / bracelet length adjustment',
  services_block_items_title_7: 'Battery replacement (quartz movement)',
  heromock_lower_service_page_title: 'Repair your watch now!',
  heromock_lower_service_page_sub_title: 'We provide 1 year warranty for all mechanical parts of the watch.',
  from: 'From',
  sell_info_title_0: 'Contact us',
  sell_info_description_0:
    'Fill in a short form to provide us with more detailed information about your timepiece. Our specialists will contact you back shortly with a quote for your watch.',
  sell_info_title_1: 'Send your watch',
  sell_info_description_1:
    'Visit our office or ship the watch to our service center for further control by our experienced watchmakers.',
  sell_info_title_2: 'Watch inspection',
  sell_info_description_2:
    'The watch will be checked in our service center to evaluate its technical condition and to confirm authenticity.',
  sell_info_title_3: 'Receive the payment',
  sell_info_description_3:
    'Once the watch is checked, you will receive the payout in a preferred way (in cash or via bank transfer).',
  trade_info_title_0: 'Contact us',
  trade_info_description_0: 'Fill in a short form to provide us with more detailed information about your timepiece.',
  trade_info_title_1: 'Get your quote for trade',
  trade_info_description_1:
    'Our specialists will contact you shortly to provide more information about the chosen timepiece.',
  trade_info_title_2: 'Send your watch',
  trade_info_description_2:
    'Handover protocol along with an exchange agreement will be prepared and signed by the both parties.',
  trade_info_title_3: 'Finalise the deal',
  trade_info_description_3:
    'Once your watch is checked and stated condition and authenticity are confirmed, parties will provide the surcharge payments in accordance.',
  commission_info_title_0: 'Contact us',
  commission_info_description_0:
    'Fill in a short form to provide us with more detailed information about your timepiece. Our specialists will contact you back shortly with a quote for your watch.',
  commission_info_title_1: 'Consignment agreement',
  commission_info_description_1:
    "Please review <a href='https://chronoprodstorageacc.blob.core.windows.net/design-documents/Consignment/Consignment%20agreement.pdf' target='_blank'>a sample of the consignment agreement.</a> Please note that the specific terms of the contract are negotiated individually.",
  commission_info_title_2: 'Bring your watch',
  commission_info_description_2:
    'The watch will be checked in our service center to make sure it is in perfect condition prior to sale.',
  commission_info_title_3: 'Enjoy your time',
  commission_info_description_3: 'Let our specialists do their best to sell your watch in the shortest time possible.',
  commission_info_title_4: 'Receive payment',
  commission_info_description_4:
    'The payment will be provided in 14 days after the sale. We take this time period to make sure that the Buyer is satisfied with the purchase.',
  heromock_commission_page_title: 'Consignment sale',
  heromock_commission_page_sub_title:
    'We are glad to provide a consignment selling of your watch. It is a carefree procedure in which you are able to delegate the entire process of selling your watch to our specialists. We will completely organize the overall sales process, from service maintenance of your watch to communication with the potential customers.',
  sell_title: 'How to sale your watch',
  trade_title: 'How to trade your watch',
  commission_title: 'Steps of consignment',
  commission_footer_text:
    '*Price of the service works required will be calculated and confirmed in advance, total amount of it will be deducted from the final payout.',
  sell_trade_transitional_title: 'Choose the appropriate request',
  sell_trade_transitional_content_title_0: 'Sell',
  sell_trade_transitional_content_title_1: 'Trade-in',
  sell_trade_transitional_content_title_2: 'Consignment',
  sell_trade_transitional_content_description_0: 'A complete and precise diagnostic of Swiss watches ',
  sell_trade_transitional_content_description_1: 'A complete and precise diagnostic of Swiss watches ',
  sell_trade_transitional_content_description_2: 'A complete and precise diagnostic of Swiss watches ',
  sell_trade_transitional_content_button_0: 'Fill in the form',
  sell_trade_transitional_content_button_1: 'Fill in the form',
  sell_trade_transitional_content_button_2: 'Fill in the form',
  sell_trade_info_0: `Call `,
  sell_trade_info_1: '+420 739 04 10 10',
  sell_trade_info_2: ` now to speak with a chrono 10:10 client advisor`,
  sell_form_title: 'Get your quote to sell',
  trade_form_title: 'Trade your watch',
  commission_form_title: 'Request consignment',
  make_an_offer: 'Make an offer',
  homepage_slider_new_arrivals_button: 'Shop collection',
  homepage_title_our_products: 'Our latest collection',
  homepage_our_products_product_card_button: 'See more',
  homepage_our_products_view_full_0: 'View full',
  homepage_our_products_view_full_1: 'Collection',
  homepage_slider_service_center_title: 'We provide service for your watch',
  homepage_slider_service_center_subtitle:
    'We provide quality service in our in-house service center for watches of any complexity beside selling high class Swiss watches',
  homepage_slider_service_center_buttons: 'Book Service',
  homepage_insta_block_title: 'Inspiration in real life',
  homepage_insta_block_subtitle: 'Want to be the first to know?',
  homepage_insta_block_info:
    'Follow our updates on Instagram, where you can be the first to know about new products, follow our daily workflow and get acquainted with the work of our service center.',
  homepage_insta_block_follow_us: 'follow us on instagram',
  homepage_our_brand_title: 'Our brand is one of the top 10 stores in Europe',
  homepage_our_brand_description_0:
    '<p>Variety of target audiences (from watch fans dreaming of their Grail watches for years to professional investors and collectors of unique pieces)</p> ',
  homepage_our_brand_description_1:
    '<p>Variety of models (there are the models for everyone. From discontinued or vintage rare watches to the incredibly demanded new models)</p> ',
  homepage_our_brand_description_2:
    '<p>Flexible prices (market demand drives pricing and these tendencies are extremely flexible. Our team of watch experts follows the market trends daily to provide our clients with the best price options and recommendations on how to invest smartly)</p> ',
  homepage_our_brand_description_3: `<p>Multi Brand luxury watches boutique <b>Chrono 10:10 was opened in October 2018 in Intercontinental boutique on Pařížská street in Prague.</b> On this street, most of the fashion and luxury watches or jewelry stores and boutiques are located (Audemars Piguet, Rolex, Patek Philippe, Louis Vuitton, Chanel, Cartier, etc). Our team of professionals quickly established a reputation as trustworthy advisers and partners among local and international watch enthusiasts.
  <br/>
  <br/>
  <b>Chrono 10:10</b> always tries to fulfill your wishes to the maximum with our professionalism and sincerity. Presenting luxury brands (like Rolex, Patek Philippe, Audemars Piguet, F.P. Journe, A. Lange & Söhne, Vacheron Constantin, IWC, Jaeger-LeCoultre, Franck Muller and others), with over 1,000 models in our galleries, <b>Chrono 10:10 strive to give people a sense of happiness</b>, because we believe that everyone is special, and that small pleasures are hidden in carefully selected details. A special place in our offer is our repair service, which has "revived" your dear memories countless times so far.</p>`,
  homepage_our_brand_description_4:
    '<p>Why is the secondary market for the luxury Swiss the best option? Here is just so</p>',
  homepage_our_brand_button: 'About Us',
  header_items_1: 'BRANDS',
  header_items_2: 'ALL WATCHES',
  header_items_7: 'New arrivals',
  header_items_4: 'SERVICE CENTER',
  header_items_8: 'Consignment',
  header_items_3: 'SELL & TRADE',
  header_items_0: 'ABOUT US',
  header_items_5: 'BLOG',
  header_items_6: 'CONTACT US',
  header_items_sell: 'Sell your watch',
  header_items_trade: 'Trade your watch',
  header_items_consignment: 'Consignment',
  header_wishlist_header: 'No products in wishlist yet',
  header_wishlist_text: 'Dear client, your wishlist is empty. Please add products by clicking',
  header_search_placeholder: 'Search',
  header_all_watches_categories_title: 'CATEGORIES',
  header_all_watches_categories_item_0: 'All watches',
  header_all_watches_categories_item_1: 'New arrivals',
  header_all_watches_categories_item_2: 'Featured brands',
  header_all_watches_categories_item_3: 'Men/Unisex watches',
  header_all_watches_categories_item_4: 'Ladies watches',
  header_all_watches_collections_title: 'COLLECTIONS',
  header_all_watches_collections_item_0: 'Best Sellers',
  header_all_watches_collections_item_1: 'Automatic Watches',
  header_all_watches_collections_item_2: 'Sport Watches',
  header_all_watches_collections_item_3: 'Steel Watches',
  header_all_watches_collections_item_4: 'Platinum Watches',
  header_all_watches_prices_title: 'PRICES',
  header_all_watches_prices_item_0: 'Less than ',
  header_all_watches_prices_item_1_0: ' to ',
  header_all_watches_prices_item_1_1: ' ',
  header_all_watches_prices_item_2_0: ' to ',
  header_all_watches_prices_item_2_1: ' ',
  header_all_watches_prices_item_3: ' 50,000+',
  header_brands_row_0_item_0: 'Patek Philippe',
  header_brands_row_0_item_1: 'Audemars Piguet',
  header_brands_row_0_item_2: 'Rolex',
  header_brands_row_0_item_3: 'Vacheron Constantin',
  header_brands_row_0_item_4: 'Breguet',
  header_brands_row_1_item_0: 'A. Lange & Söhne',
  header_brands_row_1_item_1: 'Hublot',
  header_brands_row_1_item_2: 'Jaeger-LeCoultre',
  header_brands_row_1_item_3: 'Ulysse Nardin',
  header_brands_row_1_item_4: 'Blancpain',
  header_brands_row_2_item_0: 'F.P.Journe',
  header_brands_row_2_item_1: 'Daniel Roth',
  header_brands_row_2_item_2: 'Franck Muller',
  header_brands_row_2_item_3: 'IWC',
  header_brands_row_2_item_4: 'Breitling',
  header_brands_row_3_item_0: 'Omega',
  header_brands_row_3_item_1: 'Panerai',
  header_brands_row_3_item_2: 'Zenith',
  header_brands_row_3_item_3: 'Glashütte Original',
  header_brands_row_3_item_4: 'Girard Perregaux',
  wishlist_header_title: 'Wishlist',
  wishlist_header_info_0_0: 'There are',
  wishlist_header_info_0_1: 'items on your wishlist',
  wishlist_header_info_1: 'There is 1 item on your wishlist',
  wishlist_go_to_catalog: ' Go to the catalog page',
  wishlist_item_button_text: 'Buy or trade',
  footer_title: 'Newsletter',
  footer_info:
    'Subscribe to our regular newsletter now to stay tuned on the latest products and special offers. You can cancel your subscription at any time.',
  footer_subscribe_placeholder: 'Subscribe Email',
  footer_subscribe_button_text: 'Subscribe',
  footer_subscribe_apply_form_succesful:
    'Thank you for subscribing, we will keep you updated on any news from Chrono 10:10',
  footer_subscribe_apply_form_failed: 'Something went wrong',
  footer_navlink_item_0: 'Brands',
  footer_navlink_item_1: 'All watches',
  footer_navlink_item_2: 'New arrivals',
  footer_navlink_item_3: 'Service center',
  footer_navlink_item_4: 'Consignment',
  footer_navlink_item_5: 'Sell your watch',
  footer_navlink_item_6: 'Trade your watch',
  footer_navlink_item_7: 'About us',
  footer_navlink_item_8: 'Contact us',
  footer_navlink_item_9: 'Privacy policy',
  footer_copyright_text: '© 2022 Chrono 10:10. All Rights Reserved',
  footer_navigation_menu_text: 'Navigation menu',
  address: 'Address',
  phone: 'Phone',
  email: 'Email',
  follow: 'Follow',
  callback_apply_form_alert: 'Phone or email is in incorrect format',
  callback_apply_form_alert_failed: 'Something went wrong',
  callback_contact_form_contact_us_block: 'Please contact us in any way that is convenient for you',
  callback_contact_form_not_callback_name: 'Name',
  callback_contact_form_not_callback_placeholder_name: 'Name',
  callback_contact_form_not_callback_email: 'Email',
  callback_contact_form_not_callback_placeholder_email: 'Email',
  callback_contact_form_not_callback_or: 'or',
  callback_contact_form_not_callback_phone: 'Phone',
  callback_contact_form_not_callback_placeholder_phone: 'Start phone number with +',
  callback_contact_form_contact_us_comments: 'Comments',
  callback_contact_form_contact_us_comments_contact_form_true: 'Message',
  callback_contact_form_contact_us_comments_contact_form_empty:
    'Tell us what services your watch requires! For example, professional polishing, ultrasonic cleaning, or any other relevant details.',
  callback_not_callback_and_not_contact_add_photos: 'Add Photos',
  callback_not_callback_and_not_contact_add_photos_info:
    'The more photos you include, the more accurate your valuation will be.',
  dropzone_text: 'Drag And Drop Or Choose File',
  submit: 'Submit',
  cancel: 'Cancel',
  callback_title: 'Make an offer',
  order_title: 'Order',
  contact_us_title: 'Contact us',
  sell_form_step_2: 'Step 2. Watch Details',
  sell_form_step_number: 'Watch No',
  sell_form_brand_title: 'Brand*',
  sell_form_brand_placeholder: 'Select Brand',
  sell_form_model_title: 'Model',
  sell_form_model_placeholder: 'Select Model',
  sell_form_reference_title: 'Reference Number',
  sell_form_reference_placeholder: 'Reference Number',
  sell_form_condition_title: 'Select Condition',
  sell_form_condition_placeholder: 'Select Condition',
  sell_form_box_papers_title: 'Do you have original box and papers? Please check all that apply.',
  sell_form_box_checkbox: 'Box',
  sell_form_papers_checkbox: 'Papers',
  sell_form_add_photos_title: 'Add Photos',
  sell_form_add_photos_info: 'The more photos you include, the more accurate your valuation will be.',
  sell_form_price_title: 'What is your asking price?',
  sell_form_price_placeholder: 'Insert Price',
  sell_form_currency_title: 'Currency',
  sell_form_currency_placeholder: 'Select currency',
  sell_form_comments_title: 'Comments',
  sell_form_comments_placeholder: 'Comments',
  sell_form_have_more_title: 'Have more than one watch to sell?',
  sell_form_add_more_watch_title: 'Add Additional Watch',
  trade_form_step_2: 'STEP 2. What are you looking for?',
  trade_form_step_number: 'Watch No',
  trade_form_brand_title: 'Brand*',
  trade_form_brand_placeholder: 'Select Brand',
  trade_form_model_title: 'Model',
  trade_form_model_placeholder: 'Select Model',
  trade_form_reference_title: 'Reference Number',
  trade_form_reference_placeholder: 'Reference Number',
  trade_form_trade_more: 'Have more than one watch to trade?',
  trade_form_add_more_watch_title: 'Add Additional Watch',
  trade_form_step_3: 'STEP 3. Trade-in watch details',
  trade_in_form_condition_title: 'Select Condition',
  trade_in_form_condition_placeholder: 'Select condition',
  trade_form_box_papers_title: 'Do you have original box and papers? Please check all that apply.',
  trade_form_box_checkbox: 'Box',
  trade_form_papers_checkbox: 'Papers',
  trade_form_add_photos_title: 'Add Photos',
  trade_form_add_photos_info: 'The more photos you include, the more accurate your valuation will be.',
  trade_form_price_title: 'What is your asking price?',
  trade_form_price_placeholder: 'Insert Price',
  trade_form_currency_title: 'Currency',
  trade_form_currency_placeholder: 'Select currency',
  trade_form_comments_title: 'Comments',
  trade_form_comments_placeholder: 'Comments',
  offer_form_step_1: 'STEP 1',
  offer_form_name: 'Name',
  offer_form_first_name: 'First Name',
  offer_form_name_placeholder: 'First Name',
  offer_form_last_name: 'Last Name',
  offer_form_last_name_placeholder: 'Last Name',
  offer_form_email: 'Email',
  offer_form_email_placeholder: 'Email',
  offer_form_phone: 'Phone',
  offer_form_phone_placeholder: 'Start phone number with +',
  offer_form_comments: 'Comments',
  offer_form_comments_placeholder: 'Comments',
  offer_form_country: 'Country',
  offer_form_country_placeholder: 'Select Country',
  offer_form_trade_now: 'Trade now',
  offer_form_button_submit: 'Submit',
  offer_form_button_cancel: 'Cancel',
  offer_form_button_next: 'Next',
  privacy_policy_terms_title: 'TERMS AND CONDITIONS',
  privacy_policy_terms_introduction_title: 'I. Introduction ',
  privacy_policy_terms_introduction_text_0: `<p>These Terms and Conditions (“Terms and Conditions”) regulate the relationships of parties to a purchase contract between</p> 
  <br/>
        <p><strong>CHRONO 10:10 S.R.O.</strong></p>
        <p>Reg. No. 073 58 571, VAT No. CZ 073 58 571</p>
        <p>with its registered office at Dlouhá 733/29, Nové Město</p>
        <p>110 00 Praha 1</p>
        <p>registered in the Commercial Register with the Municipal</p>
        <p>Court in Prague, File No. C298746,</p>
        <p>(„<strong>Chrono 10:10</strong>“ or „<strong>the Seller</strong>“)</p>
        <p>and the purchaser (“<strong>Purchaser</strong>”).</p>`,
  privacy_policy_terms_introduction_text_1_0: '<p>For detailed information about the Seller please visit ',
  privacy_policy_terms_introduction_text_1_1: '</p>',
  privacy_policy_terms_introduction_text_2: `<p>A purchaser is a natural person in the position of a consumer, an enterprising natural person, or a legal person.</p>
  <p> A consumer is a natural person acting privately, without any commercial purpose.</p>
  <p> An entrepreneur is a natural or legal person, acting with any commercial purpose.</p>`,
  privacy_policy_terms_introduction_text_3: `<p>The Purchaser, being a legal person, is always presumed to act as the Entrepreneur unless explicitly proved otherwise.</p>
  <p>The Purchaser, being a natural person, indicates whether acts as a consumer of an entrepreneur by presence or absence of business registration and/or VAT registration number when making an order with the Seller.</p>`,
  privacy_policy_terms_introduction_text_4: `<p>By making any order, the Purchaser confirms being completely familiar with these Terms and Conditions.</p>
  <p>The Purchaser acknowledges that the registered trademarks, trade names, company logos, etc. of the Seller are subject of exclusive usage of the Seller and cannot be used by any third party without prior written authorization at all.</p>`,
  privacy_policy_terms_introduction_text_5_0:
    '<p>Any potential Purchaser can get familiar with these Terms and Conditions online via this link: ',
  privacy_policy_terms_introduction_text_5_1: `</p>
  <p>Any potential Purchaser can obtain full copy of the actual Terms and Conditions per email request: `,
  privacy_policy_terms_introduction_text_5_2: '</p>',
  privacy_policy_terms_specific_info_title: 'II. Specific information for the consumers',
  privacy_policy_terms_specific_info_text_0:
    'The Purchaser is required to pay the purchase price before receiving the goods ordered from the Seller unless a different specific case-related arrangement is agreed upon in writing.',
  privacy_policy_terms_specific_info_text_1:
    'The parties can agree on advance payment or partial advance payment in cases when appropriate or suitable.',
  privacy_policy_terms_specific_info_text_2:
    'The parties can agree on payment cash on delivery (C.O.D.) to the delivery service staff when appropriate or suitable.',
  privacy_policy_terms_specific_info_text_3:
    'If the product is not available immediately, the Purchaser acknowledges that any his payment is considered for advance payment and/or reservation fee and will be fully counted on the retail price or returned to the Purchaser, if the desired product will be unavailable.',
  privacy_policy_terms_specific_info_text_4:
    'Unless specifically mentioned, the prices for products displayed on the website operated by the Seller are incl. domestic (CZ) VAT. No foreign taxes and duties are included at all.',
  privacy_policy_terms_specific_info_text_5:
    'Shipping costs are always subject to separate arrangements and are never included in the displayed price.',
  privacy_policy_terms_specific_info_text_6:
    'A purchaser in the position of a consumer (applicable for the territory of EU only) may withdraw from the agreement (unless otherwise stipulated below) within 14 days commencing on the day of receiving the goods (purchase agreements); provided:',
  privacy_policy_terms_specific_info_text_7:
    'The Purchaser has to return the product the the Seller in sufficient and safe package. If the condition of the returned product got worse and the product need maintenance and/or cleaning or other restoration in the previous condition etc. the costs of such procedures will be billed to the Purchaser. ',
  privacy_policy_terms_specific_info_text_8:
    'The costs incurred in association with returning the goods to the Seller (withdrawn agreements)/costs of returning the goods other than by ordinary delivery services agreed with the Seller are borne by the Purchaser, unless approved by the Seller in the advance.',
  privacy_policy_terms_specific_info_text_9:
    'For the products exceeding the retail price CZK 5000 resp. EUR 200, the appropriate delivery service including delivery confirmation service and full value insurance has to be used, unless agreed otherwise.',
  privacy_policy_terms_specific_info_text_10:
    'In the case of pre-orders, the Purchaser understands that the final price of the desired product may change. The Seller will inform the Purchaser about the final price to get the final purchase confirmation. The purchase price of the goods will be determined after the goods will be under the control of the Seller. Any difference between the estimated price and the purchase price will be refunded by the Seller or the Purchaser will pay the difference before the delivery of the goods unless the Purchaser decides to cancel the pre-order if this was specifically made as tentative. All pre-orders are considered binding unless agreed otherwise.',
  privacy_policy_terms_specific_info_list_items_0: 'The was purchased as generic',
  privacy_policy_terms_specific_info_list_items_1: 'The product was not consumed, even partially',
  privacy_policy_terms_specific_info_list_items_2:
    'The product was not obtained for the customer per specific order as a unique specimen from the third party',
  privacy_policy_terms_specific_info_list_items_3:
    'The product was not repaired/processed/renowed or otherwise altered per a specific requirement of the consumer',
  privacy_policy_terms_specific_info_list_items_4:
    'The product has no signs of usage resp. its condition was not changed ',
  privacy_policy_terms_specific_info_list_items_5: 'The product is not damaged or altered in any way',
  privacy_policy_terms_contract_title: 'III. the Contract',
  privacy_policy_terms_contract_execution_title: '1. Execution',
  privacy_policy_terms_contract_execution_text_0:
    'An order is effective when the Purchaser communicate the order to the Seller. The Purchaser may use the services of personnel of the Seller via email or phone or any similar distant communication tools. The Purchaser has to check all the details of his order carefully before its confirmation. The purchase agreement is entered into upon the moment the order submitted by a Purchaser is received by the Seller.',
  privacy_policy_terms_contract_execution_text_1:
    'The Purchaser is informed about the executed contract in a confirmation e-mail letter sent by the Seller to the e-mail address provided by the Purchaser in the order.',
  privacy_policy_terms_contract_execution_text_2:
    'The confirmation email letter is sent along with these Terms and Conditions. The executed agreement can be changed or canceled by the agreement of both the parties or in cases stipulated by law.',
  privacy_policy_terms_contract_delivery_title: '2.	Delivery',
  privacy_policy_terms_contract_delivery_text_0:
    'Under the purchase agreement, the Seller will deliver the product to the Purchaser, unless a personal pick up in the premises of the Seller is required.',
  privacy_policy_terms_contract_delivery_text_1:
    'The Purchaser shall acquire the ownership of the product only after the purchase price has been paid in full.',
  privacy_policy_terms_contract_delivery_text_2:
    'The Seller will not start delivery of the product unless the full purchase price has been paid, unless explicitly agreed otherwise.',
  privacy_policy_terms_contract_warranty_title: '3.	Warranty, risk of damage and liability',
  privacy_policy_terms_contract_warranty_text_0:
    'The Seller confirms that the goods indicated as new are free from defects. In particular, the Seller guarantees to the Purchaser that, at the moment the goods are received by the Purchaser. The goods have the characteristics announced by the Seller. The goods comply with the requirements stipulated by law. The warranty period for purchasers-consumers under the EU jurisdiction is 2 years according to the Civil Code for new products and 1 year for products offered as used. The warranty period for purchasers-entrepreneurs may be different; the different warranty period, however, applies only if explicitly stated and is applied with a priority.',
  privacy_policy_terms_contract_warranty_text_1:
    'The Purchaser has to examine the goods, its characteristics and quantity as soon as feasible after the risk of damage to the goods passes to the Purchaser. The Purchaser is obliged to inform the Seller about any detected defects and deficiencies without undue delay.',
  privacy_policy_terms_contract_warranty_text_2:
    'The risk of damage passes to the Purchaser upon accepting the goods in question; the same applies also to cases where the Purchaser rejects to accept the goods although having the possibility to do so.',
  privacy_policy_terms_contract_available_title: '4.	Available claims',
  privacy_policy_terms_contract_available_text_0:
    'If the product fail to meet the announced qualities within the specified period and such defect prevent the usual usage of the product, it constitutes a serious breach of the agreement, the Purchaser may and can:',
  privacy_policy_terms_contract_available_text_1:
    'When claiming the defect in question, the Purchaser informs the Seller as to which of the aforementioned options the Purchaser has selected and does so either immediately or without undue delay thereafter whereby the selected option can be then changed only if so approved by the Seller.',
  privacy_policy_terms_contract_available_text_2:
    'In addition to cases where the Seller cannot deliver a new product/its part, repair the product, the Purchaser may and can claim a reasonable discount from the retail price or withdraw from the contract.',
  privacy_policy_terms_contract_available_text_3:
    'If the product fail to meet the announced qualities within the specified period and such defect does not prevent the usual usage of the product, it constitutes a non-serious breach of the agreement, the Purchaser may and can:',
  privacy_policy_terms_contract_available_text_4:
    'If improper performance constitutes other than material breach, the Purchaser may and can have the defect removed or be given a reasonable discount on the purchase price.',
  privacy_policy_terms_contract_available_text_5:
    'If the Purchaser has not claimed the discount on the purchase price or withdraws from the agreement yet, the Seller may always deliver the missing parts or remove the legal defect. Other defects can be removed either by repair or delivery of a new goods.',
  privacy_policy_terms_contract_available_text_6:
    'If the Seller fails to remove the defect in due course or refuses to remove the defect, the Purchaser may claim a reasonable discount on the purchase price or withdraw from the agreement whereby the selected option can then be changed only if so approved by the Seller.',
  privacy_policy_terms_contract_available_text_7:
    'If the product cannot be used because of a repeated occurrence of the defect after repair (third claim of the same defect) or a larger number of defects (at least three defects at the same time), in such cases, the Purchaser may and can withdraw from the agreement.',
  privacy_policy_terms_contract_available_list_items_1_0:
    'have the defect removed by being delivered a new defect-free product, if available',
  privacy_policy_terms_contract_available_list_items_1_1: 'have the defect removed by repair',
  privacy_policy_terms_contract_available_list_items_1_2: 'be given a reasonable discount on the purchase price',
  privacy_policy_terms_contract_available_list_items_1_3: 'withdraw from the agreement.',
  privacy_policy_terms_contract_available_list_items_2_0:
    'have the defect removed by being delivered a new defect-free product, if available',
  privacy_policy_terms_contract_available_list_items_2_1: 'be given a reasonable discount on the purchase price',
  privacy_policy_terms_personal_data_title: 'V. Personal Data Protection and Security',
  privacy_policy_terms_personal_data_text:
    'The rules regarding personal data protection can be find here (link), being binding for the Seller and Purchaser.',
  privacy_policy_terms_miscelanious_title: 'VI. Miscellaneous provisions',
  privacy_policy_terms_miscelanious_text_0:
    'The mutual relations and any possible disputes arising from the contract between the Seller and the Purchaser shall be negotiated preferably amicably, and only if such negotiation would fail, it shall be judicially solved exclusively under the law of the Czech Republic and shall be decided by the competent courts of the Czech Republic. The United Nations Convention on Contracts for the International Sale of Goods shall not be used.',
  privacy_policy_terms_miscelanious_text_1:
    'The Purchaser-consumer may contact use the extrajudicial non judicial procedure, i.e. of the Czech Trade Inspection as mentioned here.',
  privacy_policy_terms_miscelanious_text_2:
    'The agreement is entered into in the Czech language. If the agreement is required to be translated for the Purchaser into another language, the Czech version prevails in case of discrepancies between the two language versions.',
  privacy_policy_gdpr_title_1: 'Information on the processing and protection of personal data',
  privacy_policy_gdpr_texts_1_0: `<p><strong>CHRONO 10:10 S.R.O.</strong></p>
        <p>Reg. No. 073 58 571, VAT No. CZ 073 58 571</p>
        <p>with its registered office at Vodičkova 710/31, 1 Nové Měst</p>
        <p>Město, 110 00 Praha 1</p>
        <p>registered in the Commercial Register with the Municipal</p>
        <p>Court in Prague, File No. C298746,</p>
        <p>(„<strong>Chrono 10:10</strong>“ or „<strong>the Seller</strong>“)</p>
        <p>and the purchaser (“<strong>Purchaser</strong>”).</p>`,
  privacy_policy_gdpr_texts_1_1_0: '<p>Is the operator of the website ',
  privacy_policy_gdpr_texts_1_1_1: ` (hereinafter referred to as the “website”), being obliged as a personal data controller to protect the processed personal data and to comply with obligations arising from legal regulations concerning processing and protection of personal data. </p>
  <p>The Seller provides its customers and website visitors with information on the processing and protection of personal data, in particular how the Seller handles personal data, for what purposes it uses, to whom it provides them and what are the individual rights of the persons whose personal data are processed (so-called data subjects).</p>`,
  privacy_policy_gdpr_title_2: 'Processing without consent',
  privacy_policy_gdpr_texts_2:
    'The Seller is entitled to process personal data for the following purposes without consent:',
  privacy_policy_gdpr_list_item_2_0:
    "To meet of rights and obligations arising from concluded contracts and / or orders made by the customer - personal data are processed for the duration of rights and obligations under the purchase contract ( orders), but for a maximum of 5 years; in the event that the customer does not provide The Seller with the personal data necessary for the conclusion and performance of the contract concluded on the basis of the customer's order, the order will not be accepted and the contract between the customer and The Seller will not arise; ",
  privacy_policy_gdpr_list_item_2_1: 'To maintain the proper functioning of the website;',
  privacy_policy_gdpr_list_item_2_2:
    'To maintain the protection of persons and property in the premises of the Seller ',
  privacy_policy_gdpr_list_item_2_3:
    "To keep the Seller 'legitimate interests (i. e. to process for statistical purposes) ",
  privacy_policy_gdpr_list_item_2_4: 'To assure compliance with the obligations imposed on the Seller by law',
  privacy_policy_gdpr_title_3: 'Processing limited by the consent',
  privacy_policy_gdpr_texts_3_0:
    'In the rest cases, the Seller can process the data only on the basis of granted consents to the processing of personal data. ',
  privacy_policy_gdpr_texts_3_1:
    'In such a case, The Seller processes personal data for the purposes and for the period expressed individually in each consent separately.',
  privacy_policy_gdpr_texts_3_2:
    'By providing the data to the Seller, the consent for procession of such data is given for the purpose, for which the data were provided. No one is obliged to give consent with processing of the data, where not providing such consent may prevent the Seller to provide some products/services.',
  privacy_policy_gdpr_title_4: 'Transfer of personal data',
  privacy_policy_gdpr_texts_4_0: 'The Seller may transfer personal data to third parties only:',
  privacy_policy_gdpr_texts_4_1:
    'To the extent necessary, personal data may be transferred in particular to suppliers of the Seller for the purpose of management of the services of the Seller, i. e. IT service providers, where the Seller hereby undertake to assure the protection of the data at least on the same standard there.',
  privacy_policy_gdpr_list_item_4_0: 'under the conditions stipulated by law; ',
  privacy_policy_gdpr_list_item_4_1:
    'if the handover is necessary to ensure the fulfillment of the concluded contracts and orders and/or the proper functioning of the website; ',
  privacy_policy_gdpr_list_item_4_2:
    'other persons under the conditions specified in any consent granted to the processing of personal data',
  privacy_policy_gdpr_title_5: 'Protection of personal data ',
  privacy_policy_gdpr_texts_5_0:
    'High level technical and personal security measures implemented by the Seller are used to protect the personal data processed by the Seller from unauthorized manipulation, loss, destruction or access by unauthorized persons.',
  privacy_policy_gdpr_texts_5_1:
    'The Seller is constantly developing and improving its security measures in line with technological developments.',
  privacy_policy_gdpr_title_6: 'Personal data processing rights ',
  privacy_policy_gdpr_texts_6_0:
    'Every person has the right to access their personal data possessed by the Seller, namely in order to',
  privacy_policy_gdpr_texts_6_1: 'The above rights can be exercised in written on the email address: ',
  privacy_policy_gdpr_texts_6_2:
    "<p>The supervisory body of the public administration of the Czech Republic in the area of personal data protection is the Office for Personal Data Protection with its registered office in Lt. Col. Sochora 27, postal code 170 00, Prague 7, <a href='https://uoou.cz' target='blank'>uoou.cz</a></p>",
  privacy_policy_gdpr_list_item_6_0: 'to correct incorrect personal data',
  privacy_policy_gdpr_list_item_6_1:
    'to delete personal data, when there is no more legitimate reason to keep/process it',
  privacy_policy_gdpr_list_item_6_2:
    'to limit the processing of personal data, when there is legitimate reason to limit the procession',
  privacy_policy_gdpr_list_item_6_3: 'to claim transfer of personal data to another manager, when possible',
  cookie_banner_text_0: `This website uses cookies. By clicking "Accept" button we will assume that you have accepted our`,
  cookie_banner_text_1: 'privacy policy settings',
  cookie_banner_button_accept: 'ACCEPT',
  alert_title_warning: 'Warning',
  alert_title_thank_you: 'Thank you!',
  alert_text: 'We appreciate your time and we will contact you back soon',
  alert_button_yes: 'Yes',
  alert_button_no: 'No',
  alert_button_okay: 'Okay',
  sell_trade_types_condition_new: 'New',
  sell_trade_types_condition_mint: 'Mint',
  sell_trade_types_condition_old: 'Used',
  sell_trade_types_type_buy: 'Buy',
  sell_trade_types_type_trade: 'Trade',
  sell_trade_types_type_sell: 'Sell',
  sell_trade_types_type_comission: 'Commission',
  sell_trade_form_alert_incorrect_phone: 'Phone or email is in incorrect format',
  sell_trade_link_main_page: 'Main',
  sell_trade_link_sell_trade_page: 'Sell & Trade',
  sell_trade_form_alert_brand_has_to_be_selected: 'At least the brand of product has to be selected',
  sell_trade_form_alert_failed: 'Something went wrong',
  popular_package: 'POPULAR PACKAGE',
  most_popular: 'MOST POPULAR',
  order: 'Order',
  callback_selected_service_text: 'Selected Service',
  callback_price_text: 'Price',
  callback_service_options_business: 'Business Package',
  callback_service_options_premium: 'Premium Package',
  callback_service_options_exclusive: 'Exclusive Package',
  all_watches_text_showing: 'Showing',
  all_watches_text_of: 'of',
  all_watches_text_watches: 'Watches',
  all_watches_button_loading: 'Loading...',
  all_watches_button_load_more: 'Load more',
  all_watches_loading: 'Products are loading ...',
  all_watches_no_such_product_was_found: 'No such product was found',
  all_wathces_sort_by_placeholder: 'Sort by',
  all_wathces_sort_by_newest: 'Newest',
  all_wathces_sort_by_hight_to_low: 'Price (high to low)',
  all_wathces_sort_by_low_to_hight: 'Price (low to high)',
  product_button_buy_or_trade: 'Buy or Trade',
  product_button_whatsapp: 'WhatsApp',
  product_button_call_back: 'Call Back',
  product_price_block_info_0: 'Trusted Seller on Chrono24 since 2018',
  product_price_block_info_1_0: 'Free delivery',
  product_price_block_info_1_1: 'insurance',
  product_price_block_info_2: 'Up to 2 years warranty',
  product_price_block_info_3: 'Authenticity guarantee',
  product_you_may_also_like: 'You may also like',
  product_you_may_also_like_button: 'See all collection',
  product_description: 'Description',
  product_features: 'Features',
  product_features_title_watch_details: 'Watch details',
  product_features_title_case_dial: 'Case/Dial',
  product_features_title_strap_bracelet: 'Strap/Bracelet',
  product_features_watch_details_description_key_0: 'BrandName',
  product_features_watch_details_description_key_1: 'Reference Number',
  product_features_watch_details_description_key_2: 'ModelName',
  product_features_watch_details_description_key_3: 'Scope of delivery',
  product_features_watch_details_description_key_4: 'Dealer product code',
  product_features_watch_details_description_key_5: 'Availability',
  product_features_watch_details_description_key_6: 'Condition',
  product_features_watch_details_description_key_7: 'Production year',
  product_features_case_dial_description_key_0: 'Case material',
  product_features_case_dial_description_key_1: 'Movement',
  product_features_case_dial_description_key_2: 'Case diameter',
  product_features_case_dial_description_key_3: 'Dial',
  product_features_case_dial_description_key_4: 'Crystal',
  product_features_case_dial_description_key_5: 'Bezel material',
  product_features_case_dial_description_key_6: 'Dial numerals',
  product_features_strap_bracelet_description_key_0: 'Bracelet color',
  product_features_strap_bracelet_description_key_1: 'Bracelet material',
  product_features_strap_bracelet_description_key_2: 'Clasp',
  product_features_strap_bracelet_description_key_3: 'Clasp material',
  catalog_filters_title_filter: 'Filter',
  catalog_filters_title_results: 'Results',
  catalog_filters_button_reset: 'Reset Filters',
  catalog_filters_button_apply: 'Apply Filters',
  catalog_filters_price: 'Price',
  brands_a_z_caps: 'BRANDS A - Z',
  brands_view_all_brands: 'View all brands',
  service_page_contact_form_title: 'We are at your disposal',
  service_page_phone_safe_note:
    'Your telephone number is safe with us and will only be used when necessary to contact you with further questions.',
  service_page_attachment_star: 'Attachment *',
  service_page_attachment: 'Attachment',
  validation_email_not_valid: 'Email not valid',
  validation_phone_not_valid: 'Phone not valid',
  general_error_message: 'Something went wrong',
  general_attachment_star: 'Attachment *',
  general_upload_file: 'Upload file',
  footer_stay_connected: 'Stay connected',
  footer_contact: 'CONTACT',
  blog_pager_load_more: 'Load More Articles',
  blog_pager_articles: 'Articles',
  blog_search_placeholder: 'Search articles',
  blog_article_button_read_more: 'Continue Reading',
  blog_article_related_articles: 'Related Articles',
  service_page_show_all_brands: 'SHOW ALL BRANDS',
  sell_trade_generic_step: 'STEP',
  product_delivery_help_text: 'We ship worldwide: UPS, FedEx.',
  product_shipping_and_delivery: 'Shipping and Delivery',
  product_payment_methods: 'Payment Methods',
  product_payment_methods_p1: 'For more details about online payments please contact our customer service.',
  product_payment_methods_p2:
    '*Please note that online card payment transactions are processed within 7-10 business days due to security bank compliance. Thank you for your understanding.',
  product_terms_and_conditions: 'Terms & Conditions',
  product_terms_p1:
    'We provide a 1 year warranty (or valid manufacture warranty) for any mechanical failures for all our watches.',
  product_terms_p2: 'We don’t provide VAT refund.',
  product_terms_p3: 'We accept the following payment methods:',
  product_terms_p3_1: 'Cash or card in our boutique',
  product_terms_p3_2: 'Bank transfer',
  product_terms_p3_3: 'Online card payment',
  product_terms_p3_4: 'USDC',
  product_terms_p4: '*All transactions are registered legally in accordance with the EU legislation.',
  product_terms_p5: 'Buying watches from our store, we guarantee that:',
  product_terms_p5_1: '- Authenticity',
  product_terms_p5_2: '- Watches are checked properly to ensure that they are not stolen.',
  product_terms_p5_3: '- Watches are working correctly.',
  product_terms_p5_4: '- All our pre-owned watches are serviced before being put on sale.',
  product_terms_p5_5: '- We do not sell or buy watches with serious technical defects.',
  product_terms_p6:
    "We have a broad variety of watches! In the event that we don't have a particular model in stock, it's possible to place an order though delivery might be longer",
  live_help_title: 'Welcome to Chrono 10:10',
  live_help_subtitle: 'How can we help?',
  live_help_text:
    'If you have any questions, we are happy to contact and discuss all the details. We will be in touch shortly',
  product_secure_payment: 'Secure payment via',
  contact_us_appointment_note:
    'We recommend booking your appointments in advance due to increased foot traffic in the store. This will ensure you receive the attention and service you deserve without the wait. Thank you for your understanding!',
  compare_page_title: 'Compare',
  compare_page_empty: 'No watches to compare',
  compare_remove_from: 'Remove from compare',
  compare_added_to_compare: 'Successfully added to compare',
  compare_go_to_compare: 'Go To Compare',
  compare_continue: 'Continue Shopping',
  compare_or: 'OR',
  home_page_main_title: 'CHRONO 10:10 — Luxury watch boutique and service center',

  catalog_static_used: 'Luxury used watches',
  catalog_static_mens: "Luxury men's watches",
  catalog_static_womens: "Luxury women's watches",
  catalog_static_gold: 'Luxury gold watch',
  catalog_static_automatic: 'Swiss automatic watch',
  catalog_static_mechanical: 'Swiss mechanical watch',
  catalog_static_diamond: 'Diamond watch',
  catalog_static_sapphire_glass: 'Watches with sapphire crystal',
};
